<template>
  <div class="d-md-flex min-vh-100">
    <!-- Десктоп: сайдбар -->
    <aside class="sidebar d-none d-md-flex flex-column text-white p-3">
      <div class="fw-bold fs-4 mb-3">DerSign</div>
      <nav class="nav flex-column gap-1">
        <RouterLink class="nav-link sidebar-link" to="/">Дашборд</RouterLink>

        <div class="sidebar-section">Контент</div>
        <RouterLink class="nav-link sidebar-link" to="/playlists">Плейлисты</RouterLink>
        <RouterLink class="nav-link sidebar-link" to="/library">Библиотека</RouterLink>

        <div class="sidebar-section">Настройка</div>
        <RouterLink class="nav-link sidebar-link" to="/screens">Экраны</RouterLink>
        <RouterLink class="nav-link sidebar-link" to="/venues">Заведения</RouterLink>
      </nav>
      <div class="mt-auto d-flex flex-column gap-1">
        <RouterLink class="nav-link sidebar-link" to="/apk">APK</RouterLink>
        <button class="btn btn-outline-light btn-sm mt-1" @click="onLogout">Выйти</button>
      </div>
    </aside>

    <!-- Контент -->
    <main class="flex-fill p-3 p-md-4 has-bottom-nav"><slot /></main>

    <!-- Телефон: «Ещё» поповер -->
    <div v-if="moreOpen" class="more-overlay d-md-none" @click="moreOpen = false"></div>
    <div v-if="moreOpen" class="more-panel d-md-none">
      <RouterLink class="more-item" to="/venues" @click="moreOpen = false">Заведения</RouterLink>
      <RouterLink class="more-item" to="/apk" @click="moreOpen = false">APK</RouterLink>
      <button class="more-item text-start w-100" @click="onLogout">Выйти</button>
    </div>

    <!-- Телефон: нижние табы -->
    <nav class="bottom-nav d-md-none">
      <RouterLink class="bn-item" to="/" @click="moreOpen = false">
        <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 11l9-8 9 8"/><path d="M5 10v10h14V10"/></svg>
        <span>Дашборд</span>
      </RouterLink>
      <RouterLink class="bn-item" to="/playlists" @click="moreOpen = false">
        <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 6h12"/><path d="M4 12h12"/><path d="M4 18h8"/><circle cx="19" cy="16" r="2"/></svg>
        <span>Плейлисты</span>
      </RouterLink>
      <RouterLink class="bn-item" to="/library" @click="moreOpen = false">
        <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg>
        <span>Медиа</span>
      </RouterLink>
      <RouterLink class="bn-item" to="/screens" @click="moreOpen = false">
        <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="4" width="20" height="13" rx="2"/><path d="M8 21h8"/></svg>
        <span>Экраны</span>
      </RouterLink>
      <button class="bn-item" :class="{ 'bn-active': moreOpen }" type="button" @click="moreOpen = !moreOpen">
        <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2"><circle cx="5" cy="12" r="1.6"/><circle cx="12" cy="12" r="1.6"/><circle cx="19" cy="12" r="1.6"/></svg>
        <span>Ещё</span>
      </button>
    </nav>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

const router = useRouter();
const auth = useAuthStore();
const moreOpen = ref(false);

function onLogout(): void {
  moreOpen.value = false;
  auth.logout();
  router.push('/login');
}
</script>

<style scoped>
.sidebar { width: 220px; background: #1a2332; }
.sidebar-link { color: #cdd5e0; border-radius: 6px; }
.sidebar-link:hover { background: #2a3550; color: #fff; }
.sidebar-link.router-link-exact-active { background: #3a5bd0; color: #fff; }
.sidebar-section { color: #6b7890; font-size: 11px; text-transform: uppercase; letter-spacing: .04em; padding: 10px 10px 2px; }

.bottom-nav {
  position: fixed; left: 0; right: 0; bottom: 0; z-index: 1030;
  display: flex; background: #1a2332; border-top: 1px solid #2a3550;
}
.bn-item {
  flex: 1; display: flex; flex-direction: column; align-items: center; gap: 2px;
  padding: 8px 2px; color: #9aa7bd; text-decoration: none; font-size: 11px;
  background: none; border: none;
}
.bn-item.router-link-exact-active, .bn-item.bn-active { color: #fff; }
.bn-item.router-link-exact-active svg, .bn-item.bn-active svg { color: #6e8bff; }

.more-overlay { position: fixed; inset: 0; z-index: 1029; }
.more-panel {
  position: fixed; right: 8px; bottom: 64px; z-index: 1031;
  background: #1a2332; border: 1px solid #2a3550; border-radius: 10px;
  display: flex; flex-direction: column; min-width: 160px; padding: 6px; gap: 2px;
  box-shadow: 0 6px 24px rgba(0,0,0,.4);
}
.more-item { color: #cdd5e0; text-decoration: none; padding: 10px 12px; border-radius: 6px; background: none; border: none; }
.more-item:hover, .more-item.router-link-exact-active { background: #2a3550; color: #fff; }
</style>
